import { isPromise } from './yoto-api';
import STAGES from './stages';
import axios from 'axios';
import { getAccessToken } from './AuthService';

const ICON_DOMAIN =
    STAGES.ICONS_DOMAINS[STAGES.CLIENT_URLS[window.location.hostname]];
const ICONS_API_DOMAIN =
    STAGES.ICONS_API_DOMAINS[STAGES.CLIENT_URLS[window.location.hostname]];

const HTTPS_PREFIX = 'https://';
const HTTP_PREFIX = 'http://';

export const YOTO_MEDIA_URL_PREFIX = 'yoto:#';

function isUrl(mediaId) {
    return mediaId.startsWith(HTTP_PREFIX) || mediaId.startsWith(HTTPS_PREFIX);
}

export function getIconUrl(mediaId, url) {
    if (!mediaId) return null;
    if (url) {
        return url;
    }
    if (isPromise(mediaId)) {
        return mediaId.then((data) => {
            return data;
        });
    }

    if (isUrl(mediaId)) return mediaId;
    if (mediaId.startsWith(YOTO_MEDIA_URL_PREFIX))
        mediaId = mediaId.split(YOTO_MEDIA_URL_PREFIX)[1];
    return `${ICON_DOMAIN}/icons/${mediaId}`;
}

async function getDisplayIconV2Url(mediaId) {
    const url = `${ICONS_API_DOMAIN}/icons/${encodeURIComponent(mediaId)}`;
    const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${getAccessToken()}` }
    });
    if (!response.data.url) {
        console.error(`Failed to get data: ${url}`);
        return null;
    }
    return response.data.url;
}

async function getIconsByMediaIds(mediaIds) {
    const result = {};
    const promises = mediaIds.map(
        async (mediaId) =>
            (result[mediaId] = await getDisplayIconV2Url(mediaId))
    );
    await Promise.all(promises);
    return result;
}

export async function replaceAllIconURLsOnTheCard(card) {
    const { content } = card;
    const { chapters } = content;
    const neededMediaIds = new Set();
    for (const chapter of chapters) {
        if (
            chapter.display &&
            chapter.display.icon16x16 &&
            !chapter.display.icon16x16.startsWith('https://')
        ) {
            neededMediaIds.add(chapter.display.icon16x16);
        }

        for (const track of chapter.tracks) {
            if (
                track.display &&
                track.display.icon16x16 &&
                !track.display.icon16x16.startsWith('https://')
            ) {
                neededMediaIds.add(track.display.icon16x16);
            }
        }
    }
    if (neededMediaIds.size === 0) {
        return card;
    }

    const iconMap = await getIconsByMediaIds([...neededMediaIds]);
    const newChapters = chapters.map((chapter) => {
        const newTracks = chapter.tracks.map((track) => {
            if (
                track.display &&
                track.display.icon16x16 &&
                iconMap[track.display.icon16x16]
            ) {
                return {
                    ...track,
                    display: {
                        ...track.display,
                        icon16x16: iconMap[track.display.icon16x16]
                    }
                };
            }
            return track;
        });

        let updatedChapter = {
            ...chapter,
            tracks: newTracks
        };

        if (chapter.display.icon16x16 && iconMap[chapter.display.icon16x16]) {
            updatedChapter = {
                ...updatedChapter,
                display: {
                    ...chapter.display,
                    icon16x16: iconMap[chapter.display.icon16x16]
                }
            };
        }

        return updatedChapter;
    });

    return {
        ...card,
        content: {
            ...content,
            chapters: newChapters
        }
    };
}

const YOTO_MEDIA_PREFIX = 'yoto:#';

export const getMediaIdFromIcon = (iconString) => {
    if (!iconString) return;

    if (iconString.startsWith(YOTO_MEDIA_PREFIX)) {
        return iconString;
    }

    if (iconString && iconString.startsWith('http')) {
        // Get last bit
        const lastSlash = iconString.lastIndexOf('/');
        const mediaId = iconString.substring(lastSlash + 1);
        return `${YOTO_MEDIA_PREFIX}${mediaId}`;
    }

    return `${YOTO_MEDIA_PREFIX}${iconString}`;
};
